import { render, staticRenderFns } from "./BookRoom.vue?vue&type=template&id=81f26efe&scoped=true"
import script from "./BookRoom.vue?vue&type=script&lang=js"
export * from "./BookRoom.vue?vue&type=script&lang=js"
import style0 from "./BookRoom.vue?vue&type=style&index=0&id=81f26efe&prod&lang=scss&scoped=true"
import style1 from "./BookRoom.vue?vue&type=style&index=1&id=81f26efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f26efe",
  null
  
)

export default component.exports